export default __webpack_public_path__ + "static/media/health.e0450dfc.svg";